import { useEffect } from 'react';

type useRedirectToManualProps = {
  homeId?: string;
};

function useRedirectToManual({ homeId }: useRedirectToManualProps) {
  useEffect(() => {
    const lastId = localStorage.getItem('lastId');

    if (!homeId && lastId) {
      window.location = `/${lastId}` as any;
    }
  }, [homeId]);
}

export default useRedirectToManual;
